import { render, staticRenderFns } from "./PhoneNumberDropdownItem.vue?vue&type=template&id=5a00b15a&scoped=true"
import script from "./PhoneNumberDropdownItem.vue?vue&type=script&lang=js"
export * from "./PhoneNumberDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberDropdownItem.vue?vue&type=style&index=0&id=5a00b15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00b15a",
  null
  
)

export default component.exports